export const MainConfig = {
    AppDetails: {
        app_name: "EshopDelivery", 
        app_description: "EshopDelivery smart drivers services",
        app_identifier: "com.eshop.delivery",
        ios_app_version: "4.0.0",
        android_app_version: 4
    },
    Expo: {
        projectId: "477310ae-3497-427e-b6dc-c146a996c419",
        owner: "devpapanik",
        targetSdkVersion: 33,
        buildToolsVersion: "33.0.0"
      },
    FirebaseConfig: {
    apiKey: "AIzaSyCQhUAzyNsEaxTsckRatyJJU3oMlckr2Nw",
    authDomain: "eshop-delivery.firebaseapp.com",
    databaseURL: "https://eshop-delivery-default-rtdb.firebaseio.com",
    projectId: "eshop-delivery",
    storageBucket: "eshop-delivery.appspot.com",
    messagingSenderId: "771885531169",
    appId: "1:771885531169:web:0bd717f10a8287e1946360"
    },

    Google_Map_API_Key: {
        ios: "AIzaSyDhOwas8Fl9Q9ZD1dmP-3Q1CtEhqmyziPc",
        android: "AIzaSyB_Dw1UBG_-2bgcsdHEIiE8xi3A-3QFHyA",
        web: "AIzaSyCQhUAzyNsEaxTsckRatyJJU3oMlckr2Nw"
    },
}
